import { useState } from "react";
import type { ProductionRun, ProductionReferenceData } from "./models";
import { TouchQuantitySheet } from "./TouchQuantitySheet";
import { TouchSheet } from "./TouchSheet";
import { useQuantityUnitOptions } from "./useQuantityUnitOptions";
import { useHistoricalScrapWrite } from "./useHistoricalScrapWrite";
import { useTerminalSupervisors } from "./useTerminalSupervisors";

export function HistoricalProductScrapSheet({run,terminalCode,sessionId,operatorId,preview,reasons,draftKey,close,onSaved}:{
  run:ProductionRun;terminalCode:string;sessionId:string;operatorId:string;preview:boolean;
  reasons:ProductionReferenceData["reasons"];draftKey:string;close:()=>void;onSaved:()=>void;
}) {
  const units=useQuantityUnitOptions(run.id,terminalCode);
  const supervisors=useTerminalSupervisors(terminalCode,sessionId);
  const write=useHistoricalScrapWrite({run,terminalCode,sessionId,operatorId,preview,onSaved});
  const [supervisorId,setSupervisorId]=useState("");
  const [pin,setPin]=useState("");
  const [occurredAt,setOccurredAt]=useState("");
  const [error,setError]=useState<string|null>(null);
  const supervisorChoice=supervisors.items.some(item=>item.id===supervisorId)?supervisorId:"";
  const sendPending=async()=>{
    try {setError(null);await write.reauthorizePending({supervisorId:supervisorChoice,pin});}
    catch(caught){setError(caught instanceof Error?caught.message:"Bekleyen kayıt gönderilemedi.");}
    finally{setPin("");}
  };
  if(write.pending)return <TouchSheet title="Bekleyen geçmiş ıskarta kaydı" variant="quantity" close={close} closeDisabled={write.saving}>
    <div className="touch-form">{supervisors.error?<p role="alert">{supervisors.error}<button type="button" onClick={supervisors.retry}>Amir listesini yeniden oku</button></p>:null}<p>İşlem kimliği cihazda korunuyor. Yeni kayıt oluşturmadan önce sunucu sonucunu kontrol edin.</p>
      <button type="button" disabled={write.saving} onClick={()=>void write.verifyPending()}>Sonucu kontrol et</button>
      <label>Vardiya amiri<select disabled={write.saving} value={supervisorChoice} onChange={event=>setSupervisorId(event.target.value)}><option value="">Seçin</option>{supervisors.items.map(item=><option key={item.id} value={item.id}>{item.name}</option>)}</select></label>
      <label>4 haneli PIN<input type="password" inputMode="numeric" autoComplete="off" maxLength={4} value={pin} onChange={event=>setPin(event.target.value.replace(/\D/gu,"").slice(0,4))}/></label>
      <button type="button" disabled={write.saving||!supervisorChoice||!/^\d{4}$/u.test(pin)} onClick={()=>void sendPending()}>Aynı kaydı yeniden onayla</button>
      {write.error||error?<p role="alert">{error??write.error}</p>:null}
    </div>
  </TouchSheet>;
  return <>
    <TouchQuantitySheet type="SCRAP" unit={run.unit} productCode={run.productCode} productName={run.productName} reasons={reasons}
      saving={write.saving||supervisors.loading} unitContract={units.contract} unitsLoading={units.loading} unitsError={units.error} retryUnits={units.retry}
      draftKey={draftKey} preview={preview} close={close} historicalApproval={{error:supervisors.error,retry:supervisors.retry,supervisors:supervisors.items,supervisorId:supervisorChoice,pin,occurredAt,setSupervisorId,setPin,setOccurredAt}}
      submit={async(draft,localDraft,approval)=>{
        if(!approval)throw new Error("Vardiya amiri onayı gerekli.");
        try{await write.submit(draft,approval,localDraft);}finally{setPin("");}
      }}/>
  </>;
}
